@let opp = opportunity();
<nav class="ocnav" aria-label="Active opportunity">
  <button
    type="button"
    class="app-btn app-btn--ghost app-btn--compact app-btn--block app-btn--start app-type-nav app-tone-text-muted ocnav__back"
    (click)="navigateBack()"
  >
    <span class="pi pi-chevron-left" aria-hidden="true"></span>
    All opportunities
  </button>

  <div class="ocnav__header">
    <h2 class="ocnav__title app-type-title-sm app-tone-text-title">
      {{ opp.title }}<span class="app-title-inline-gap" aria-hidden="true"></span>
      @if (opp.cNumber) {
        <span class="app-cnum-plain app-title-inline-code">{{ opp.cNumber }}</span>
      } @else {
        <span class="app-cnum-plain app-cnum-plain--pending app-title-inline-code"
          >C-number pending</span
        >
      }
    </h2>
    <p class="ocnav__account app-type-meta app-tone-text-subtle">{{ opp.client }}</p>
  </div>

  <ul class="ocnav__links" role="list">
    <li>
      <a
        class="ocnav__link app-type-nav"
        [routerLink]="overviewRouteSegments(opp.id)"
        routerLinkActive="ocnav__link--active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="pi pi-home" aria-hidden="true"></span>
        <span>Overview</span>
      </a>
    </li>
    <li>
      <a
        class="ocnav__link app-type-nav"
        [routerLink]="qualificationRouteSegments(opp.id)"
        routerLinkActive="ocnav__link--active"
      >
        <span class="pi pi-list-check" aria-hidden="true"></span>
        <span>Qualification wizard</span>
      </a>
    </li>
    <li>
      @if (startBidEnabled()) {
        <a
          class="ocnav__link app-type-nav"
          [routerLink]="startBidRouteSegments(opp.id)"
          routerLinkActive="ocnav__link--active"
        >
          <span class="pi pi-play" aria-hidden="true"></span>
          <span>Start bid</span>
        </a>
      } @else {
        <span class="ocnav__link ocnav__link--disabled app-type-nav" aria-disabled="true">
          <span class="pi pi-play" aria-hidden="true"></span>
          <span>Start bid</span>
        </span>
      }
    </li>
  </ul>
</nav>
